import React, { FC, useState, useEffect } from 'react'
import styles from 'styles/components/template.module.scss'
import { MainHeadline, Description } from 'components/Typography'
import { FormLabel } from 'components/Label'
import { Checkbox } from 'components/Form'
import { BlueButton, NavButton } from 'components/Button'
import { Spacer } from 'components/Utility'
import { useDispatch, useSelector } from 'react-redux'
import { State } from 'index'
import { useCheckbox } from 'hooks/form'
import { getConfirmBrand } from 'reducks/brand/selectors'
import { fetchStoreStaffs } from 'repos/staff'
import { BrandState } from 'types/brand'
import { StaffType } from 'types/staff'
import { saveBrand } from 'reducks/brand/operations'

const BrandManagerTemplate: FC = () => {
  const dispatch = useDispatch()
  const confirmBrand: BrandState['confirm'] = useSelector((state: State) => getConfirmBrand(state))
  const [staffs, setStaffs] = useState<StaffType[]>([])
  const [storeManagerIds, setStoreManagerIds] = useState<string[]>([])
  const handleStoreManagerIds = useCheckbox(setStoreManagerIds)

  useEffect(() => {
    ;(async () => {
      if (confirmBrand.store_refs.length === 0) return
      const res = await Promise.all(confirmBrand.store_refs.map((storeRef) => fetchStoreStaffs(storeRef)))
      const staffs = res.flat()
      setStaffs([...staffs])
      setStoreManagerIds([
        ...staffs
          .filter((staff) => staff.roles.some((role) => role.brand_ref?.id === confirmBrand.brand_ref?.id))
          .map((staff) => staff.uid),
      ])
    })()
  }, [confirmBrand])

  return (
    <div className={styles.standard}>
      <Spacer size={28} />
      <MainHeadline headline={'ブランド管理者を設定する'} />
      <Spacer size={28} />
      <Description description={`${confirmBrand.name}のブランドマネージャーに紐付ける人を登録してください。`} />
      <Spacer size={48} />
      <FormLabel label={'ユーザー'} required={false} />
      <Spacer size={8} />
      {staffs
        .reduce((prev: StaffType[], staff) => {
          if (!prev.some((_staff) => _staff.uid === staff.uid)) {
            return [...prev, staff]
          } else {
            return prev
          }
        }, [])
        .map((staff: StaffType) => (
          <div key={staff.uid}>
            <Checkbox
              id={staff.uid}
              isChecked={storeManagerIds.includes(staff.uid)}
              onChange={handleStoreManagerIds}
              label={staff.email}
            />
          </div>
        ))}
      <Spacer size={48} />
      <BlueButton
        endIconPath={'/icon/white/arrow_next_small.svg'}
        label={'登録する'}
        onClick={() => dispatch(saveBrand(confirmBrand, storeManagerIds))}
        size={'medium'}
        type={'main'}
      />
      <Spacer size={24} />
      <NavButton label={'トップページに戻る'} iconPath={'/icon/grey/home.svg'} url={'/admin/shops'} />
      <Spacer size={48} />
    </div>
  )
}
export default BrandManagerTemplate
